module.exports = __webpack_public_path__ + "static/media/бе.1890852d.mp3";